import { useTranslation } from "react-i18next"

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useUseCasesStore } from "@/stores/use-cases-store"

import { DashboardTab } from "./dashboard/dashboard-tab"
import { FactSheetTab } from "./fact-sheet/fact-sheet-tab"

export function UseCasesTabs() {
  const { t } = useTranslation()
  const { activeTab, setActiveTab } = useUseCasesStore()

  return (
    <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as "dashboard" | "factsheet")}>
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="dashboard">{t("useCases.tabs.dashboard")}</TabsTrigger>
        <TabsTrigger value="factsheet">{t("useCases.tabs.factSheet")}</TabsTrigger>
      </TabsList>

      <TabsContent className="mt-6" value="dashboard">
        <DashboardTab />
      </TabsContent>

      <TabsContent value="factsheet">
        <FactSheetTab />
      </TabsContent>
    </Tabs>
  )
}
